module.exports = vadpUI;


//////////////////
// WEBPACK FOOTER
// external "vadpUI"
// module id = 16
// module chunks = 0